import styles from "./avatar.styles.module.scss";
import classNames from "classnames";
import { PendingPersonIcon } from "../../../icons/pending-person.icon";

export const COLOR_CLASSES = ["gartner-blue", "surf", "tangerine", "rose", "sky"];

type AvatarComponentProps = {
  text?: string;
  color?: "gartner-blue" | "rose" | "surf" | "sky" | "tangerine";
  invert?: boolean;
  size?: "xs" | "s" | "m" | "l";
  showFullText?: boolean;
};

export const AvatarComponent = ({
  text = "",
  color,
  invert = false,
  size = "m",
  showFullText = false,
}: AvatarComponentProps) => {
  const initials = text.trim().split(/\s+/).slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join("") || "";
  const getColorClassByName = () => COLOR_CLASSES[[...text].reduce((sum, char) => sum + char.charCodeAt(0), 0) % COLOR_CLASSES.length];
  const colorClass = color || getColorClassByName();

  return (
    <div
      className={classNames(
        styles.avatar,
        styles[size],
        styles[colorClass as keyof typeof styles],
        {
          [styles.invert]: invert,
          [styles.unknownUser]: !text,
          [styles.showFullText]: showFullText && Boolean(text),
        }
      )}
    >
      {text ? showFullText ? text : initials : <PendingPersonIcon />}
    </div>
  );
};
